module.exports = __webpack_public_path__ + "img/img_pxzc.faa116a4.jpg";